import React, { useEffect } from 'react';
import NavTagline from '../../../nav-tagline/nav-tagline';
import FormUserContact from './FormUserContact';
import Footer from '../../../shared/Footer';

const PreRegistration = () => {
    useEffect(() => {
        const heading = document.querySelector("h1.form-title");
        if (heading) {
            heading.setAttribute("tabindex", "-1");
            heading.focus();
        }
    }, []);

    return (
    <div className="PreRegistration">
        <NavTagline />
        <main className="layout-container">
            <div 
                className="container"
                tabIndex="-1"
            >
                <div className="descript-container container-2">
                    <h1 className="form-title g-clr">Almost Done!</h1>
                    <p>If you have an NPI (National Provider Identifier) number, enter the
                    10-digit identification number. Otherwise, enter the information below to complete the registration.</p>
                </div>
                <FormUserContact />
            </div>
        </main>
        <Footer />
        </div>
    )
};


export default PreRegistration;
